export const stickerZapatosTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '160px',
        fontSize: '22px',
        left: '102px',
        top: '179px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '160px',
        fontSize: '22px',
        left: '306px',
        top: '179px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '160px',
        fontSize: '22px',
        left: '102px',
        top: '381px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '160px',
        fontSize: '22px',
        left: '306px',
        top: '381px',
    });

    return coords;
};

export const stickerRedondoTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '100px',
        fontSize: '22px',
        left: '146px',
        top: '123px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '100px',
        fontSize: '22px',
        left: '314px',
        top: '123px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '100px',
        fontSize: '22px',
        left: '146px',
        top: '283px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '100px',
        fontSize: '22px',
        left: '314px',
        top: '283px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '100px',
        fontSize: '22px',
        left: '146px',
        top: '443px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '100px',
        fontSize: '22px',
        left: '314px',
        top: '443px',
    });

    return coords;
};

export const stickerRedondo2Template = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '100px',
        fontSize: '22px',
        left: '161px',
        top: '130px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '100px',
        fontSize: '22px',
        left: '340px',
        top: '130px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '100px',
        fontSize: '22px',
        left: '161px',
        top: '287px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '100px',
        fontSize: '22px',
        left: '340px',
        top: '287px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '100px',
        fontSize: '22px',
        left: '161px',
        top: '443px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '100px',
        fontSize: '22px',
        left: '341px',
        top: '443px',
    });

    return coords;
};

export const stickerCuadradoTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '100px',
        fontSize: '14px',
        left: '166px',
        top: '122px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '100px',
        fontSize: '14px',
        left: '303px',
        top: '122px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '100px',
        fontSize: '14px',
        left: '166px',
        top: '238px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '100px',
        fontSize: '14px',
        left: '303px',
        top: '238px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '100px',
        fontSize: '14px',
        left: '166px',
        top: '354px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '100px',
        fontSize: '14px',
        left: '303px',
        top: '354px',
    });
    // Position 7
    coords.push({
        position: 6,
        width: '100px',
        fontSize: '14px',
        left: '166px',
        top: '470px',
    });
    // Position 8
    coords.push({
        position: 7,
        width: '100px',
        fontSize: '14px',
        left: '303px',
        top: '470px',
    });

    return coords;
};

export const stickerCuadrado2Template = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '100px',
        fontSize: '14px',
        left: '168px',
        top: '154px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '100px',
        fontSize: '14px',
        left: '314px',
        top: '154px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '100px',
        fontSize: '14px',
        left: '168px',
        top: '270px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '100px',
        fontSize: '14px',
        left: '314px',
        top: '270px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '100px',
        fontSize: '14px',
        left: '168px',
        top: '385px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '100px',
        fontSize: '14px',
        left: '314px',
        top: '385px',
    });

    return coords;
};

export const stickerCuadernoTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '85px',
        fontSize: '20px',
        left: '282px',
        top: '114px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '85px',
        fontSize: '20px',
        left: '282px',
        top: '287px',
    });

    return coords;
};

export const stickerGrandeTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '220px',
        fontSize: '24px',
        left: '212px',
        top: '134px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '220px',
        fontSize: '24px',
        left: '212px',
        top: '220px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '220px',
        fontSize: '24px',
        left: '212px',
        top: '310px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '220px',
        fontSize: '24px',
        left: '212px',
        top: '399px',
    });

    return coords;
};

export const stickerMedianoTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '125px',
        fontSize: '24px',
        left: '260px',
        top: '110px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '125px',
        fontSize: '24px',
        left: '260px',
        top: '203px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '125px',
        fontSize: '24px',
        left: '260px',
        top: '298px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '125px',
        fontSize: '24px',
        left: '260px',
        top: '393px',
    });

    return coords;
};

export const stickerPequenoTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '132px',
        fontSize: '16px',
        left: '242px',
        top: '72px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '132px',
        fontSize: '16px',
        left: '242px',
        top: '126px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '132px',
        fontSize: '16px',
        left: '242px',
        top: '180px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '132px',
        fontSize: '16px',
        left: '242px',
        top: '234px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '132px',
        fontSize: '16px',
        left: '242px',
        top: '288px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '132px',
        fontSize: '16px',
        left: '242px',
        top: '342px',
    });
    // Position 7
    coords.push({
        position: 6,
        width: '132px',
        fontSize: '16px',
        left: '242px',
        top: '395px',
    });
    // Position 8
    coords.push({
        position: 7,
        width: '132px',
        fontSize: '16px',
        left: '242px',
        top: '449px',
    });

    return coords;
};

export const stickerMiniTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '39px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '77px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '115px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '153px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '191px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '229px',
    });
    // Position 7
    coords.push({
        position: 6,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '267px',
    });
    // Position 8
    coords.push({
        position: 7,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '305px',
    });
    // Position 9
    coords.push({
        position: 8,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '344px',
    });
    // Position 10
    coords.push({
        position: 9,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '382px',
    });
    // Position 11
    coords.push({
        position: 10,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '420px',
    });
    // Position 12
    coords.push({
        position: 11,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '458px',
    });
    // Position 13
    coords.push({
        position: 12,
        width: '150px',
        fontSize: '14px',
        left: '232px',
        top: '496px',
    });

    return coords;
};

export const ropaCuadradaTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '98px',
        fontSize: '14px',
        left: '167px',
        top: '163px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '98px',
        fontSize: '14px',
        left: '314px',
        top: '163px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '98px',
        fontSize: '14px',
        left: '167px',
        top: '278px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '98px',
        fontSize: '14px',
        left: '314px',
        top: '278px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '98px',
        fontSize: '14px',
        left: '167px',
        top: '395px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '98px',
        fontSize: '14px',
        left: '314px',
        top: '395px',
    });

    return coords;
};

export const ropaGrandeTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '214px',
        fontSize: '22px',
        left: '210px',
        top: '118px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '214px',
        fontSize: '22px',
        left: '210px',
        top: '188px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '214px',
        fontSize: '22px',
        left: '210px',
        top: '256px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '214px',
        fontSize: '22px',
        left: '210px',
        top: '324px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '214px',
        fontSize: '22px',
        left: '210px',
        top: '392px',
    });

    return coords;
};

export const ropaPequenaTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '86px',
        fontSize: '16px',
        left: '186px',
        top: '88px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '86px',
        fontSize: '16px',
        left: '347px',
        top: '88px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '86px',
        fontSize: '16px',
        left: '186px',
        top: '155px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '86px',
        fontSize: '16px',
        left: '347px',
        top: '155px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '86px',
        fontSize: '16px',
        left: '186px',
        top: '221px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '86px',
        fontSize: '16px',
        left: '347px',
        top: '221px',
    });
    // Position 7
    coords.push({
        position: 6,
        width: '86px',
        fontSize: '16px',
        left: '186px',
        top: '286px',
    });
    // Position 8
    coords.push({
        position: 7,
        width: '86px',
        fontSize: '16px',
        left: '347px',
        top: '286px',
    });
    // Position 9
    coords.push({
        position: 8,
        width: '86px',
        fontSize: '16px',
        left: '186px',
        top: '352px',
    });
    // Position 10
    coords.push({
        position: 9,
        width: '86px',
        fontSize: '16px',
        left: '347px',
        top: '352px',
    });
    // Position 11
    coords.push({
        position: 10,
        width: '86px',
        fontSize: '16px',
        left: '186px',
        top: '418px',
    });
    // Position 12
    coords.push({
        position: 11,
        width: '86px',
        fontSize: '16px',
        left: '347px',
        top: '418px',
    });

    return coords;
};

export const ropaRedondaTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '100px',
        fontSize: '20px',
        left: '152px',
        top: '130px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '100px',
        fontSize: '20px',
        left: '336px',
        top: '130px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '100px',
        fontSize: '20px',
        left: '152px',
        top: '286px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '100px',
        fontSize: '20px',
        left: '336px',
        top: '286px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '100px',
        fontSize: '20px',
        left: '152px',
        top: '442px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '100px',
        fontSize: '20px',
        left: '336px',
        top: '442px',
    });

    return coords;
};

export const comboColegioTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '169px',
        fontSize: '20px',
        left: '141px',
        top: '36px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '98px',
        fontSize: '18px',
        left: '400px',
        top: '32px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '106px',
        fontSize: '12px',
        left: '114px',
        top: '128px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '117px',
        fontSize: '12px',
        left: '336px',
        top: '136px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '82px',
        fontSize: '12px',
        left: '118px',
        top: '263px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '82px',
        fontSize: '14px',
        left: '372px',
        top: '259px',
    });
    // Position 7
    coords.push({
        position: 6,
        width: '166px',
        fontSize: '18px',
        left: '110px',
        top: '341px',
    });
    // Position 8
    coords.push({
        position: 7,
        width: '80px',
        fontSize: '14px',
        left: '336px',
        top: '405px',
    });
    // Position 9
    coords.push({
        position: 8,
        width: '82px',
        fontSize: '12px',
        left: '58px',
        top: '478px',
    });
    // Position 10
    coords.push({
        position: 9,
        width: '65px',
        fontSize: '12px',
        left: '348px',
        top: '471px',
    });

    return coords;
};

export const comboJardinTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '175px',
        fontSize: '20px',
        left: '132px',
        top: '67px',
    });
    // Position 2
    coords.push({
        position: 1,
        width: '93px',
        fontSize: '20px',
        left: '400px',
        top: '62px',
    });
    // Position 3
    coords.push({
        position: 2,
        width: '74px',
        fontSize: '14px',
        left: '139px',
        top: '208px',
    });
    // Position 4
    coords.push({
        position: 3,
        width: '114px',
        fontSize: '12px',
        left: '362px',
        top: '196px',
    });
    // Position 5
    coords.push({
        position: 4,
        width: '164px',
        fontSize: '18px',
        left: '110px',
        top: '340px',
    });
    // Position 6
    coords.push({
        position: 5,
        width: '80px',
        fontSize: '14px',
        left: '336px',
        top: '406px',
    });
    // Position 7
    coords.push({
        position: 6,
        width: '65px',
        fontSize: '12px',
        left: '95px',
        top: '436px',
    });

    return coords;
};

export const comboRopaTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '86px',
        fontSize: '16px',
        left: '255px',
        top: '61px',
    });

    // Position 2
    coords.push({
        position: 1,
        width: '189px',
        fontSize: '22px',
        left: '220px',
        top: '199px',
    });

    // Position 3
    coords.push({
        position: 2,
        width: '100px',
        fontSize: '18px',
        left: '129px',
        top: '346px',
    });

    // Position 4
    coords.push({
        position: 3,
        width: '98px',
        fontSize: '14px',
        left: '349px',
        top: '341px',
    });

    return coords;
};

export const comboStickerTemplate = () => {
    const coords = [];
    // Position 1
    coords.push({
        position: 0,
        width: '135px',
        fontSize: '14px',
        left: '249px',
        top: '45px',
    });

    // Position 2
    coords.push({
        position: 1,
        width: '125px',
        fontSize: '24px',
        left: '143px',
        top: '120px',
    });

    // Position 3
    coords.push({
        position: 2,
        width: '132px',
        fontSize: '14px',
        left: '372px',
        top: '130px',
    });

    // Position 4
    coords.push({
        position: 3,
        width: '220px',
        fontSize: '24px',
        left: '207px',
        top: '246px',
    });

    // Position 5
    coords.push({
        position: 4,
        width: '100px',
        fontSize: '18px',
        left: '138px',
        top: '408px',
    });

    // Position 6
    coords.push({
        position: 5,
        width: '100px',
        fontSize: '14px',
        left: '354px',
        top: '412px',
    });

    return coords;
};
